import { EnergyCalculation } from "../services/portfolioApi"

type Breakdown = EnergyCalculation["breakdowns"][number]

const toCategoryKey = (category?: string) => category || "Unknown"

const capitalise = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1)

const aggregateByField = (
  breakdowns: Breakdown[],
  field: "electricityKwh" | "gasKwh"
) =>
  breakdowns.reduce<Record<string, number>>((acc, breakdown) => {
    const value = parseFloat(breakdown[field] || "0")
    if (value <= 0) return acc
    const key = capitalise(toCategoryKey(breakdown.category))
    acc[key] = (acc[key] || 0) + value
    return acc
  }, {})

export const getCalculationForOccupiers = (
  energyCalculations: EnergyCalculation[],
  occupiers: number
) =>
  energyCalculations.find((calc) => calc.numOccupiers === occupiers) || null

export const getElectricityUsageData = (breakdowns: Breakdown[]) => {
  const totals = aggregateByField(breakdowns, "electricityKwh")
  return {
    totals,
    chartData: Object.entries(totals).map(([name, value]) => ({ name, value }))
  }
}

export const getGasUsageData = (breakdowns: Breakdown[]) => {
  const totals = aggregateByField(breakdowns, "gasKwh")
  return {
    totals,
    chartData: Object.entries(totals).map(([name, value]) => ({ name, value }))
  }
}

